<template>
  <nav :class="[baseCss, setTextColor(), lastItemDisabled ? `${baseCss}-last-item-disabled` : null, 'select-none', `text-${align}`]">
    <ul :class="['barebone-list', 'inline-list', 'truncate', 'py-2']">
      <slot />
    </ul>
  </nav>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Breadcrumbs',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('breadcrumbs')
    }
  },
  props: {
    delimiter: {
      type: String,
      default: '/'
    },
    lastItemDisabled: {
      type: Boolean,
      default: true
    },
    underline: {
      type: Boolean
    },
    color: {
      type: String,
      default: 'black'
    },
    tag: {
      type: String,
      default: 'a',
      validator: value => {
        return ['a', 'router-link'].includes(value)
      }
    },
    target: {
      type: String
    },
    align: {
      type: String,
      default: 'auto',
      validator: value => {
        return ['left', 'center', 'right', 'justify', 'auto'].includes(value)
      }
    }
  }
}
</script>
<style>
.bcq-breadcrumbs ul:empty,
.bcq-breadcrumbs li:last-child .bcq-breadcrumbs-item-delimiter
{
  display: none;
}

.bcq-breadcrumbs .bcq-breadcrumbs-item-delimiter,
.bcq-breadcrumbs.bcq-breadcrumbs-last-item-disabled li:last-child a
{
  filter: grayscale(100);
  text-decoration: none;
}

.bcq-breadcrumbs
{
  font-size: 14px;
  font-weight: 400;
}

.bcq-breadcrumbs a:hover
{
  text-decoration: underline;
}

.bcq-breadcrumbs.bcq-breadcrumbs-last-item-disabled li:last-child a
{
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/breadcrumbs/breadcrumbs.vue